import { Stopwatch, StopwatchStatus } from '@/types';

export const formatCircleTime = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return minutes > 0 ? `${hours}ч ${minutes}м` : `${hours}ч`;
  }

  if (minutes > 0) {
    return seconds > 0 ? `${minutes}м ${seconds}с` : `${minutes}м`;
  }

  return `${seconds} сек`;
};

export const formatDigitalTime = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }

  return `${pad(minutes)}:${pad(seconds)}`;
};

export const calcElapsedSeconds = (stopwatch: Stopwatch, clockOffset: number): number => {
  if (stopwatch.status === StopwatchStatus.Running && stopwatch.startedAt) {
    const serverEpoch = new Date(stopwatch.startedAt).getTime();
    const elapsed = Math.floor((Date.now() - serverEpoch - clockOffset) / 1000);

    return stopwatch.accumulatedSeconds + Math.max(0, elapsed);
  }

  return stopwatch.accumulatedSeconds;
};
